import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GroupType } from '../enums/enums';
import { SessionService } from '../services/session.service';
import { CustomNavigationService } from '../services/custom-navigation.service';
import { ServicesService } from '../services/services.service';

@Injectable({
  providedIn: 'root',
})
export class KimboGuard implements CanActivate {
  constructor(
    public authService: SessionService,
    public services: ServicesService,
    public navigationService: CustomNavigationService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isLoggedIn() && this.authService.hasRole(GroupType.Kimbo)) {
      let currentRole = this.authService.getCurrentRole();
      let groupType = GroupType;
      let role;
      if (currentRole.group.type !== groupType.Kimbo) {
        if (this.authService.hasRole(GroupType.Kimbo)) {
          role = this.authService.getRole(GroupType.Kimbo);
          currentRole = role;
          this.services.roleService.changeRole(role, state.url);
        }
      }
      return true;
    } else {
      this.authService.logout();
      // Notifier danger
      return false;
    }
  }
}
